import { render } from "./PpcStrategiesConfirmUpdateModal.vue?vue&type=template&id=14ca98c8&scoped=true"
import script from "./PpcStrategiesConfirmUpdateModal.vue?vue&type=script&lang=js"
export * from "./PpcStrategiesConfirmUpdateModal.vue?vue&type=script&lang=js"

import "./PpcStrategiesConfirmUpdateModal.vue?vue&type=style&index=0&id=14ca98c8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ca98c8"]])

export default __exports__